<div class="action-container" *appHasRole="['Admin', 'Manager', 'Preparer']">
  <app-ag-action-icon-button
    iconClass="ic-notes-16"
    [disabled]="!params.data?.entityId"
    (action)="openNotes()"
  />

  <app-ag-action-icon-button
    iconClass="ic-eye-16"
    (action)="openDocument()"
  />

  <div
    ngbDropdown
    container="body"
    class="dropdown d-inline-flex"
    [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
  >
    <app-ag-action-icon-button
      ngbDropdownToggle
      iconClass="ic-more-horizontal-16"
    />

    <div ngbDropdownMenu class="common-dropdown-menu dropdown-menu dropdown-menu-right">
      @for (item of visibleActions; track item) {
        <button
          ngbDropdownItem
          type="button"
          class="dropdown-item"
          (click)="item.action()">
          <i class="{{item.iconClass}}"></i>
          <span>{{ item.title }}</span>
        </button>
      }
    </div>
  </div>
</div>
